import { Link } from "react-router-dom";
import { ScanSearch } from "lucide-react";

export default function Footer() {
  return (
    <footer
      className="border-t border-[#0A0A0A] bg-white mt-24"
      data-testid="site-footer"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-12 grid md:grid-cols-4 gap-8">
        <div>
          <div className="flex items-center gap-2.5">
            <span className="w-8 h-8 grid place-items-center bg-[#0047FF] text-white">
              <ScanSearch className="w-5 h-5" strokeWidth={2.4} />
            </span>
            <span className="font-display text-xl tracking-tight">
              Privacy<span className="text-[#0047FF]">Lens</span>
            </span>
          </div>
          <p className="text-sm text-[#475569] mt-4 leading-relaxed">
            AI-powered website trust intelligence. See your hidden privacy &amp;
            compliance risks before they become expensive.
          </p>
        </div>

        <div>
          <div className="font-mono text-[11px] uppercase tracking-widest text-[#475569] mb-3">
            Product
          </div>
          <ul className="space-y-2 text-sm">
            <li>
              <Link to="/" className="hover:text-[#0047FF]" data-testid="footer-home">
                Free Scan
              </Link>
            </li>
            <li>
              <Link to="/pricing" className="hover:text-[#0047FF]" data-testid="footer-pricing">
                Pricing
              </Link>
            </li>
            <li>
              <Link to="/recent" className="hover:text-[#0047FF]" data-testid="footer-recent">
                Public Reports
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <div className="font-mono text-[11px] uppercase tracking-widest text-[#475569] mb-3">
            Resources
          </div>
          <ul className="space-y-2 text-sm">
            <li>
              <Link to="/#features" className="hover:text-[#0047FF]">
                Features
              </Link>
            </li>
            <li>
              <Link to="/#how-it-works" className="hover:text-[#0047FF]">
                How it works
              </Link>
            </li>
            <li>
              <Link to="/#faq" className="hover:text-[#0047FF]">
                FAQ
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <div className="font-mono text-[11px] uppercase tracking-widest text-[#475569] mb-3">
            Legal
          </div>
          <ul className="space-y-2 text-sm mb-4">
            <li>
              <a href="/legal/privacy.html" className="hover:text-[#0047FF]" data-testid="footer-privacy">
                Privacy Policy
              </a>
            </li>
            <li>
              <a href="/legal/terms.html" className="hover:text-[#0047FF]" data-testid="footer-terms">
                Terms of Service
              </a>
            </li>
            <li>
              <a href="/legal/cookies.html" className="hover:text-[#0047FF]" data-testid="footer-cookies">
                Cookie Policy
              </a>
            </li>
          </ul>
          <p className="text-xs text-[#475569] leading-relaxed">
            <strong className="text-black">PrivacyLens is not a law firm and does not provide legal advice.</strong>{" "}
            All reports, scores, recommendations, and generated documents are AI-generated
            assessments based on publicly available information and automated analysis.
            Results may be incomplete, inaccurate, or may not reflect your organization&apos;s
            full compliance posture. Use of PrivacyLens does not create an attorney&ndash;client
            relationship. For legal advice or compliance determinations, consult a qualified attorney.
          </p>
        </div>
      </div>

      <div className="border-t border-[#E2E8F0]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-[#475569]">
          <div>© {new Date().getFullYear()} PrivacyLens — a product of WebNet KDR. All rights reserved.</div>
          <div className="font-mono uppercase tracking-widest">
            Built for the AI-trust era
          </div>
        </div>
      </div>
    </footer>
  );
}
